import Dashboard from "@pages/Dashboard";
import DashboardVendorAudits from "@pages/Dashboard/VendorAudits";
import DashboardLicense from "@pages/Dashboard/License";
import DashboardCompliance from "@pages/Dashboard/Compliance";
import DashboardSelfCompliance from "@pages/Dashboard/SelfCompliance";
import DashboardActivity from "@pages/Dashboard/Activity";
import ComplianceCertificate from "@pages/ComplianceCertificate";
import CertificateSummary from "@pages/CertificateSummary";
import EmailLog from "@pages/Admin/EmailLog";
import DashboardActivityOld from "@pages/Dashboard/Activity/activity-old";
import VendorCompliance from "@pages/Dashboard/VendorCompliance";

export const DashboardRoutes = [
	// { path: "/dashboard", name: "Dashboard", component: Dashboard },
	{
		path: "/dashboard/vendor-audits",
		name: "dashboard_vendor_audit",
		component: DashboardVendorAudits,
	},
	{
		path: "/dashboard/compliance",
		name: "dashboard_compliance",
		component: DashboardCompliance,
	},
	{
		path: "/dashboard/license",
		name: "dashboard_license",
		component: DashboardLicense,
	},
	{
		path: "/dashboard/self-compliance/my-activity",
		name: "dashboard_self_compliance_my_activity",
		component: DashboardActivityOld,
	},
	{
		path: "/dashboard/self-compliance/my-activity-v2",
		name: "dashboard_self_compliance_my_activity",
		component: DashboardActivity,
	},
	{
		path: "/dashboard/self-compliance/compliance",
		name: "dashboard_self_compliance_compliance",
		component: DashboardSelfCompliance,
	},
	{
		path: "/report/compliance-certificate",
		name: "report_certificate",
		component: ComplianceCertificate,
	},
	{
		path: "/report/certificate-summary",
		name: "report_certificate_summary",
		component: CertificateSummary,
	},

	//emai Log
	{
		path: "/report/logs/email-logs",
		name: "admin_system_email_log",
		component: EmailLog,
	},

	{
		path: "/dashboard/vendor-compliance",
		name: "dashboard_compliance",
		component: VendorCompliance,
	},
];
